import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import { APPLICATION_FORM_ID } from '../constants';

function FormWrapper({ ReactHookFormProps, asyncOptions, schema, onSubmit }) {
  return (
    <form
      id={APPLICATION_FORM_ID}
      onSubmit={(e) => {
        e.preventDefault();

        const formValues = ReactHookFormProps.getValues();

        onSubmit(formValues);
      }}
    >
      <Box paddingLeft={5.5}>
        <Form
          ReactHookFormProps={ReactHookFormProps}
          fields={schema}
          asyncOptions={asyncOptions}
        />
      </Box>
    </form>
  );
}

export default FormWrapper;
